export const servicos = {
  software: {
    slug: "/desenvolvimento-de-software",
    titulo: "Desenvolvimento de software sob medida | Hawx Soluções",
    descricao: "Software house em Orleans, SC. Software personalizado para empresas de Criciúma, Tubarão, Urussanga, Lauro Müller e região: sistemas web, mobile e desktop.",
    rotulo: "Desenvolvimento de software",
    h1: "Desenvolvimento de software sob medida para a sua empresa",
    destaque: "sob medida",
    subtitulo: "Sistemas web, mobile e desktop feitos do jeito que a sua operação funciona, do diagnóstico à entrega.",
    imagemAlt: "Smartwatch flutuando sobre um fundo azul, exibindo a tela de um aplicativo feito sob medida.",
    chamada: "Sistemas sob medida para o seu processo",
    resumo: "Desenvolvemos sistemas web, mobile e desktop, com design responsivo, do jeito que a sua operação funciona.",
    linkTexto: "Sobre o desenvolvimento de software",
    cta: "Pedir um orçamento",
    mensagem: "Olá! Quero um orçamento para desenvolvimento de software sob medida.",
    secoes: [
      {
        rotulo: "Desenvolvimento de software",
        titulo: "Para quem é",
        texto: "Somos uma empresa de desenvolvimento de software, uma software house, em Orleans, Santa Catarina. Criamos software personalizado para empresas e empreendedores que precisam de um sistema próprio, feito para o jeito como trabalham, e não de uma ferramenta que obriga a operação a se adaptar.",
        itens: [
          { titulo: "Gestão de clientes e pedidos", texto: "Cadastro, histórico, orçamentos e acompanhamento em um só lugar, com os campos que a sua equipe realmente usa." },
          { titulo: "Controle de estoque e produção", texto: "Entradas, saídas e etapas de produção registradas no momento em que acontecem." },
          { titulo: "Relatórios e painéis", texto: "Os números que você precisa para decidir, prontos sem ninguém montar planilha no fim do mês." },
          { titulo: "Integração com o que já existe", texto: "O sistema novo conversa com as ferramentas que a empresa já usa, em vez de substituir tudo." },
        ],
      },
      {
        rotulo: "Entrega",
        titulo: "O que entregamos",
        itens: [
          { titulo: "Sistema web, mobile ou desktop", texto: "Você escolhe onde o sistema vai ser usado: no navegador, no celular ou no computador da operação." },
          { titulo: "Design responsivo", texto: "Funciona bem em qualquer tela, do celular do vendedor ao monitor do escritório." },
          { titulo: "Implantação na operação", texto: "Colocamos o sistema para rodar no seu dia a dia, com os dados e as pessoas de verdade." },
          { titulo: "Suporte depois da entrega", texto: "O trabalho não termina na entrega. Ajustamos e acompanhamos o uso." },
        ],
      },
      {
        rotulo: "Método Hawx",
        titulo: "Como funciona",
        numerada: true,
        itens: [
          { titulo: "Conversa no WhatsApp", texto: "Você conta onde está o gargalo no seu processo, do seu jeito. Sem compromisso e sem formulário." },
          { titulo: "Diagnóstico", texto: "Visitamos a sua empresa, mapeamos o processo e apontamos o que resolver primeiro." },
          { titulo: "Proposta", texto: "Orçamento gratuito, com escopo e prazo definidos antes de qualquer trabalho começar." },
          { titulo: "Desenvolvimento e entrega", texto: "Você acompanha o andamento, recebe o sistema implantado e tem suporte depois da entrega." },
        ],
      },
    ],
    perguntas: [
      { p: "Quanto custa desenvolver um software sob medida?", r: "Depende do escopo. Por isso a primeira etapa é um diagnóstico, e a proposta vem com orçamento gratuito, escopo e prazo definidos antes de qualquer trabalho começar." },
      { p: "Quanto tempo leva?", r: "O prazo é definido na proposta, de acordo com o que o sistema precisa fazer. Você acompanha o andamento durante todo o desenvolvimento." },
      { p: "Vocês atendem empresas fora de Orleans?", r: "Sim. O diagnóstico é presencial em Orleans e nas cidades vizinhas, como Tubarão, Criciúma, Urussanga, Lauro Müller e Braço do Norte. O desenvolvimento, a implantação e o suporte acontecem com acompanhamento à distância, para empresas de toda Santa Catarina." },
      { p: "E depois da entrega, fico sem apoio?", r: "Não. O sistema é implantado na sua operação e você tem suporte depois da entrega." },
      { p: "Vocês também automatizam o que a empresa já usa?", r: "Sim. Além de desenvolver sistemas, conectamos qualquer sistema, planilha, e-mail ou ferramenta que a empresa já usa para que o trabalho repetitivo aconteça sozinho." },
    ],
  },
  automacao: {
    slug: "/automacao-de-processos",
    titulo: "Automação de processos empresariais | Hawx Soluções",
    descricao: "Automação de processos empresariais em Orleans, SC e região. Conectamos sistemas, planilhas e e-mails para que o trabalho repetitivo aconteça sozinho.",
    rotulo: "Automação de processos",
    h1: "Automação de processos: o trabalho repetitivo acontece sozinho",
    destaque: "acontece sozinho",
    subtitulo: "Conectamos as ferramentas que a sua empresa já usa e o trabalho repetitivo passa a acontecer sem ninguém fazer na mão.",
    imagemAlt: "Notebook flutuando sobre um fundo azul. Na tela, um sistema com os registros organizados automaticamente.",
    chamada: "O trabalho repetitivo acontece sozinho",
    resumo: "Conectamos qualquer sistema, planilha, e-mail ou ferramenta que a sua empresa já usa, para que lançamentos, relatórios e avisos aconteçam sozinhos.",
    linkTexto: "O que dá para automatizar",
    cta: "Quero automatizar",
    mensagem: "Olá! Quero automatizar um processo da minha empresa.",
    secoes: [
      {
        rotulo: "Automação de processos",
        titulo: "O que dá para automatizar",
        texto: "Automação de processos empresariais e administrativos: conectamos qualquer sistema, planilha, e-mail ou ferramenta que a sua empresa já usa, para que lançamentos, relatórios, avisos e o que mais precisar aconteçam sem ninguém fazer na mão.",
        itens: [
          { titulo: "Lançamentos", texto: "O que entra por um canal é registrado nos outros, sem digitar duas vezes." },
          { titulo: "Relatórios", texto: "Montados e enviados sozinhos, no dia e no formato que você define." },
          { titulo: "Avisos", texto: "Vencimentos, pendências e etapas concluídas chegam a quem precisa saber, no WhatsApp ou no e-mail." },
          { titulo: "Integração entre ferramentas", texto: "Sistemas que não conversam entre si passam a trocar informação automaticamente." },
        ],
      },
      {
        rotulo: "Método Hawx",
        titulo: "Como funciona",
        numerada: true,
        itens: [
          { titulo: "Conversa no WhatsApp", texto: "Você conta qual tarefa consome tempo da equipe todo dia." },
          { titulo: "Diagnóstico", texto: "Mapeamos o processo e as ferramentas envolvidas e apontamos o que automatizar primeiro." },
          { titulo: "Proposta", texto: "Orçamento gratuito, com escopo e prazo definidos antes de começar." },
          { titulo: "Automação e acompanhamento", texto: "A automação entra na operação e você tem suporte depois da entrega." },
        ],
      },
    ],
    perguntas: [
      { p: "Preciso trocar os sistemas que já uso?", r: "Não. A automação conecta o que a empresa já usa. Trocar de ferramenta só acontece se fizer sentido para você." },
      { p: "Que tipo de tarefa vale a pena automatizar?", r: "A que se repete todo dia e depende de alguém lembrar: lançar, conferir, avisar, consolidar. Quanto mais repetitiva, maior o ganho." },
      { p: "Quanto custa?", r: "Depende do processo e das ferramentas envolvidas. O orçamento é gratuito e vem com escopo e prazo definidos." },
      { p: "E se o processo mudar depois?", r: "A automação é ajustada. Você tem suporte depois da entrega." },
    ],
  },
  diagnostico: {
    slug: "/diagnostico-de-processos",
    titulo: "Diagnóstico de processos para empresas | Hawx Soluções",
    descricao: "Diagnóstico presencial de processos em Orleans, Criciúma, Tubarão, Urussanga, Lauro Müller e região. Mapeamos a operação e apontamos o que resolver primeiro.",
    rotulo: "Diagnóstico de processos",
    h1: "Diagnóstico de processos: encontre o gargalo antes do cliente",
    destaque: "encontre o gargalo",
    subtitulo: "Visitamos a sua empresa, mapeamos os processos no dia a dia e entregamos um plano claro do que resolver primeiro.",
    imagemAlt: "Celular flutuando sobre um fundo azul, exibindo gráficos de análise de dados.",
    chamada: "Encontramos o gargalo no processo antes que ele chegue ao cliente",
    resumo: "Visitamos a sua empresa, mapeamos os processos no dia a dia e entregamos um plano claro do que automatizar primeiro.",
    linkTexto: "Como funciona o diagnóstico",
    cta: "Agendar diagnóstico",
    mensagem: "Olá! Quero agendar um diagnóstico dos processos da minha empresa.",
    secoes: [
      {
        rotulo: "Diagnóstico de processos",
        titulo: "O que você recebe",
        texto: "O diagnóstico é presencial e sem compromisso. Saímos da visita com o mapa de como o trabalho acontece hoje e com um plano do que resolver primeiro, seja com um sistema sob medida, seja com automação.",
        itens: [
          { titulo: "Mapa dos processos", texto: "Como o trabalho acontece de verdade, etapa por etapa, com quem faz e com qual ferramenta." },
          { titulo: "Gargalos apontados", texto: "Onde o processo para, onde se repete e onde depende da memória de alguém." },
          { titulo: "Plano do que fazer primeiro", texto: "Uma ordem clara de prioridades, com o que resolver com sistema e o que resolver com automação." },
          { titulo: "Proposta sem compromisso", texto: "Se fizer sentido seguir, o orçamento é gratuito e vem com escopo e prazo definidos." },
        ],
      },
      {
        rotulo: "Método Hawx",
        titulo: "Como funciona",
        numerada: true,
        itens: [
          { titulo: "Conversa no WhatsApp", texto: "Você conta onde está o gargalo na operação, do seu jeito." },
          { titulo: "Visita presencial", texto: "Acompanhamos o processo acontecendo, com as pessoas e as ferramentas de verdade." },
          { titulo: "Plano entregue", texto: "Você recebe o mapa, os gargalos e a ordem do que resolver primeiro." },
        ],
      },
    ],
    perguntas: [
      { p: "O diagnóstico tem custo?", r: "A conversa inicial é sem compromisso e o orçamento é gratuito. Se o diagnóstico tiver custo, ele é combinado antes da visita." },
      { p: "Quanto tempo dura a visita?", r: "Depende do tamanho da operação. O suficiente para ver o processo acontecendo de ponta a ponta." },
      { p: "Sou obrigado a contratar o sistema depois?", r: "Não. O plano é seu. Seguir com desenvolvimento ou automação é uma decisão à parte." },
      { p: "Vocês fazem diagnóstico fora de Orleans?", r: "Sim. O diagnóstico é presencial em Orleans e nas cidades vizinhas, como Tubarão, Criciúma, Urussanga, Lauro Müller e Braço do Norte. Fale no WhatsApp com a localização da sua empresa e combinamos a visita." },
    ],
  },
};
